<script>
import moment from 'moment';
import Loader from '../../components/Loader.vue';

export default {
    components: {
        Loader,
    },

    metaInfo: {
        title: 'Notifications',
    },

    filters: {
        formatDate(date) {
            return moment(date).format('DD-MM-YYYY HH:mm');
        },

    },


    data() {
        return {
            isLoading: false,
            isMore: true,
            notifications: [],
            page: 1,
        };
    },

    
    async mounted() {
        this.loadNotifications();
    },

    methods: {
        async loadNotifications() {
            this.isLoading = true;

            const notifications = await window.axios.get('/api/user/notifications', 
                { params: { page: this.page } });
            this.notifications = this.notifications.concat(notifications.data.data);
            this.page += 1;

            if (notifications.data.data.length === 0) {
                this.isMore = false;
            }


            this.isLoading = false;
        },
    },
};
</script>

<template lang="pug" src='./template/Notifications.pug'></template>
<style lang="stylus" src='./styles/Notifications.styl' scoped></style>